import * as React from "react";
const SvgStar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m8.77 12.75-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L8.77 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z", fill: "#FA7268" }));
export default SvgStar;
